export default __webpack_public_path__ + "static/media/shareIcon.cc6a80c8.png";